// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._5ral1f51{object-fit:contain}\n._bfhku67f{background-color:#fff}\n._c71l1osq{max-height:100%}\n._p12f1osq{max-width:100%}", ""]);
// Exports
module.exports = exports;
